import React from "react";
import { useLocation } from "react-router-dom";
import DepositPageBlock from "@/components/DepositPageBlock";
import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import style from "./style.less";
import DownloadFloatBall from "@/components/DownloadFloatBall";
import { FromInstalled } from "@/utils/BroswerHelper";
function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}


const Deposit = () => {
  const query = useQuery();
  const backTo = query.get("back_to");

  const [backToUrl, setBackToUrl] = React.useState("");
  const [downloadFloatBall, setDownloadFloatBall] = React.useState(false);
  React.useEffect(() => {
    //有backTo的时候，记住要跳转回去的页面
    if (backTo) {
      setBackToUrl(backTo);
    }
    //没有backTo的时候不管，防止注册登录互切的时候，backTo丢失
    console.log("backTo", backTo);
  }, [backTo]);
  React.useEffect(() => {
    //下载悬浮球
    if (!FromInstalled) {
      setDownloadFloatBall(true);
    }
  }, []);
  return (
    <div class={style.deposit_page_container}>
      <HomeHeaderOther title={"Deposit"} backToUrl={backToUrl} />
      <DepositPageBlock />
      <DownloadFloatBall floatBall={downloadFloatBall} onClose={() => setDownloadFloatBall(false)} />
    </div>
  );
};

export default Deposit;
